import {useState} from "react";
import {
  HighlightedField,
  HighlightFieldIFace,
  SetHighlightedField,
} from "@/hooks/use-highlight-field";
import {Outlet} from "react-router-dom";

export function HighlightFieldProvider() {
  const [highlightedField, setHighlightedField] = useState<HighlightFieldIFace>(
    {},
  );
  
  return (
    <HighlightedField.Provider value={highlightedField}>
      <SetHighlightedField.Provider value={setHighlightedField}>
        <Outlet/>
      </SetHighlightedField.Provider>
    </HighlightedField.Provider>
  );
}
